import '@/user/common';
import React from 'react';
import ReactDom from 'react-dom';
import PhotoGallery from '@/shared/components/photo_gallery/';

const photoGallery = document.getElementById('photo-gallery');
let photos = photoGallery.dataset.photos;
let categoryId = photoGallery.dataset.photo_gallery_category_id;
let categories = photoGallery.dataset.photo_gallery_categories;
let accentColor = photoGallery.dataset.accent_color;
if (!categoryId) {
    categoryId = null;
} else {
    categoryId = categoryId >> 0;
}
if (photoGallery) {
    ReactDom.render(
        <PhotoGallery
            categories={JSON.parse(categories)}
            categoryId={categoryId}
            photos={JSON.parse(photos)}
            accentColor={accentColor}
        />,
        photoGallery,
    );
}
